export default __webpack_public_path__ + "static/media/lock.432f5cd9.svg";